import { Budget } from '../../../@types/budget';
import api from '../../../services/api/api';

export const deleteBudget = async (budgetId: string) => {
  const { data } = await api.delete(`/budget/${budgetId}`);
  return data;
};

export const getBudget = async (query = '') => {
  const { data } = await api.get<Budget[]>('/budget/v2', {
    params: {
      query,
    },
  });
  return data;
};

export const getBudgetById = async (id: string) => {
  const { data } = await api.get<Budget>(`/budget/${id}`);

  return data;
};
